import React from 'react'
import { APP_NAME } from 'configs/AppConfig';
import { APP_VERSION, APP_COMMIT, APP_BUILD_DATE, APP_ENV } from 'configs/VersionConfig';

export default function Footer() {
	return (
		<footer className="footer">
			<span>Copyright  &copy;  {`${new Date().getFullYear()}`} <span className="font-weight-semibold">{`${APP_NAME}`}</span> Todos los derechos reservados.</span>
			<span className="text-muted" title={`Build ${APP_BUILD_DATE}`}>
				{`v${APP_VERSION} · ${APP_COMMIT}`}{APP_ENV !== 'production' && ` · ${APP_ENV}`}
			</span>
		</footer>
	)
}
